/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import SortableList from './sortableList/container';
import arrayMove from 'array-move';

import '../styles.scss';
import _ from 'lodash';
import { PUT, DELETE } from '../../../../../api';
import { DefaultContainerContext } from '../../../../../contexts/defaultContainer';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import NProgressCustom from '../../../../../components/nProgress';
import CssPinner from '../../../../../components/csspinner';

type PropsType = {
  isOpen: boolean,
  handleShowModal: (boolean) => void,
  partsData: [] | null,
  eventId: string,
  upPartsData: (data: []) => void
};

class EventPageTicketPreviewEditMenuModal extends React.Component<PropsType> {
  static contextType = DefaultContainerContext;

  constructor(props: PropsType, context: {}) {
    super(props, context);

    this.state = {
      items: [],
      isLocked: false
    };
  }

  componentDidMount() {
    this.setState({
      items: _.sortBy(this.props.partsData, (p: {}): number => p.placement_index)
    });
  }

  handleSave = async (setStatus: (string) => void) => {
    const { items } = this.state;
    const { eventId } = this.props;

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });

    const newData = _.map(items, (item: any, index: number): {} => {
      item.placement_index = index + 1;

      return item;
    });

    try {
      const { success } = await PUT(`/api/v1/1/splashpages/${eventId}/placementindex`, newData);

      if (success) {
        this.setState({
          isLocked: false
        }, () => {
          setStatus('success');

          this.handleClose();

          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'success',
            systemDialogTitle: 'Great!',
            systemDialogContent: 'Parts placement changed'
          });
        });
      }
    } catch (e) {
      console.log(e);

      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Oops',
        systemDialogContent: 'Can\'t parts placement change'
      });
    }
  }

  handleClose = (): any => {
    const { handleShowModal } = this.props;

    handleShowModal(false);
  };

  onSortEnd = ({ oldIndex, newIndex }: any) => {
    this.setState(({ items }: any): any => ({
      items: arrayMove(items, oldIndex, newIndex)
    }));
  };

  handleRemovePart = async ({ type, id }: {}, index: number) => {
    const { eventId } = this.props;
    const items = _.clone(this.state.items);

    CssPinner(document.body, true);
    NProgressCustom(true);

    try {
      await DELETE(`/api/v1/1/splashpages/${eventId}/${_.toLower(type)}/${id}`);

      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully'
      });

      CssPinner(document.body, false);
      NProgressCustom(false);

      items.splice(index, 1);

      this.setState({ items });

      this.props.upPartsData(items);
    } catch (errors) {
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: !errors ?
          'Can\'t remove section' :
          _.map(errors, (er: {}): string => `${er.message}\n\n`)
      });

      CssPinner(document.body, false);
      NProgressCustom(false);
    }
  };

  handleRemoveTicket = ({ type, id }: {}, index: number) => {
    this.context.handleShowSystemDialog(true, {
      systemDialogType: 'warning',
      systemDialogTitle: 'Hmmm...',
      systemDialogContent: 'Sure you want to delete this section?',
      systemDialogData: {
        setEventStatus: this.handleRemovePart,
        eventStatus: null
      },
      systemDialogCallback: () => {
        this.handleRemovePart({ type, id }, index);
      }
    });
  };

  render(): React.Element<'div'> {
    const { items } = this.state;
    const { isOpen } = this.props;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
      >
        <div
          className="modal-dialog customModal EventPageTicketPreviewCustomizeModal splash-editor-modal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span>Splash page menu editor</span>
              </h4>
            </div>

            <div className="modal-body">
              <div className="sortable-item">
                <div className="panel panel-default panel-ticket panel-active">
                  <div className="panel-heading" style={{ background: '#fff' }}>
                    <div className="panel-title">
                      General Info
                    </div>
                  </div>
                </div>
              </div>
              <div className="sortable-item">
                <div className="panel panel-default panel-ticket panel-active">
                  <div className="panel-heading" style={{ background: '#fff' }}>
                    <div className="panel-title">
                      Tickets
                    </div>
                  </div>
                </div>
              </div>
              {!!_.size(items) &&
                <SortableList
                  helperClass='sortableHelper'
                  items={items}
                  onSortEnd={this.onSortEnd}
                  useDragHandle
                  useWindowAsScrollContainer
                  disableAutoscroll
                  handleRemoveTicket={this.handleRemoveTicket}
                />
              }
            </div>

            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Cancel</button>
              <div className="custom-pb-container">
                <BtnLoader
                  label='Save'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    this.handleSave(setStatus);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageTicketPreviewEditMenuModal;
